module.exports = __webpack_public_path__ + "img/2.532278b4.svg";